import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'ai-tool', {
    readUserProfile: 'Read user profile',
    readUserProfileReasoning: 'Reading user profile',
    readUserProfileOutput: 'Read user profile',
    readUserProfileError: 'Error reading user profile',
    updateUserProfile: 'Update user profile',
    updateUserProfileReasoning: 'Updating user profile',
    updateUserProfileOutput: 'Updated user profile',
    updateUserProfileError: 'Error updating user profile',
    updateUserProfileForm: 'Update user profile from form',
    updateUserProfileFormReasoning: 'Presenting user profile form',
    updateUserProfileFormOutput: 'Updated user profile from form',
    updateUserProfileFormError: 'Error updating user profile from form',
  });
}
